const scenarioImages = {
  uav: require('@/assets/images/industry-products/scenarios/uav.jpg'),
  unmannedVehicle: require('@/assets/images/industry-products/scenarios/unmanned-vehicle.jpg'),
  smartAgriculture: require('@/assets/images/industry-products/scenarios/smart-agriculture.jpg'),
  engineeringMachinery: require('@/assets/images/industry-products/scenarios/engineering-machinery.jpg'),
  stabilizedPlatform: require('@/assets/images/industry-products/scenarios/stabilized-platform.jpg'),
  robot: require('@/assets/images/industry-products/scenarios/robot.jpg')
}

const commonScenarios = [
  { key: 'uav', image: scenarioImages.uav },
  { key: 'unmannedVehicle', image: scenarioImages.unmannedVehicle },
  { key: 'smartAgriculture', image: scenarioImages.smartAgriculture },
  { key: 'engineeringMachinery', image: scenarioImages.engineeringMachinery },
  { key: 'stabilizedPlatform', image: scenarioImages.stabilizedPlatform },
  { key: 'robot', image: scenarioImages.robot }
]

const commonDescriptionTags = [
  { key: 'gnss', image: require('@/assets/images/pixso-industry-detail/icon-gnss.svg') },
  { key: 'mcu', image: require('@/assets/images/pixso-industry-detail/icon-mcu.svg') },
  { key: 'gyro', image: require('@/assets/images/pixso-industry-detail/icon-gyro.svg') }
]

const commonFeatureTags = [
  { key: 'calibration', image: require('@/assets/images/pixso-industry-detail/icon-calibration.svg') },
  { key: 'vehicleGrade', image: require('@/assets/images/pixso-industry-detail/icon-car.svg') },
  { key: 'lowPower', image: require('@/assets/images/pixso-industry-detail/icon-low-power.svg') },
  { key: 'environment', image: require('@/assets/images/pixso-industry-detail/icon-environment.svg') }
]

const domainDescriptionTags = [
  { key: 'network', image: require('@/assets/images/pixso-industry-detail/icon-4g5g.svg') },
  { key: 'imu', image: require('@/assets/images/pixso-industry-detail/icon-imu.svg') },
  { key: 'wifi', image: require('@/assets/images/pixso-industry-detail/icon-wifi.svg') },
  { key: 'gnss', image: require('@/assets/images/pixso-industry-detail/icon-gnss.svg') },
  { key: 'bus', image: require('@/assets/images/pixso-industry-detail/icon-rk3588j.svg') }
]

const domainFeatureTags = [
  { key: 'compute', image: require('@/assets/images/pixso-industry-detail/icon-compute.svg') },
  { key: 'fusion', image: require('@/assets/images/pixso-industry-detail/icon-fusion.svg') },
  { key: 'integration', image: require('@/assets/images/pixso-industry-detail/icon-integration.svg') },
  { key: 'environment', image: require('@/assets/images/pixso-industry-detail/icon-environment.svg') }
]

const commonSpecTabs = [
  {
    labelKey: 'ProductSpecs.tabs.basic',
    rows: [
      { labelKey: 'ProductSpecs.rows.dimensionsWithEars', value: '99x99x26mm' },
      { labelKey: 'ProductSpecs.rows.weightBare', value: '157+/-20g' },
      {
        labelKey: 'ProductSpecs.rows.dataInterface',
        value: [
          { valueKey: 'ProductSpecs.values.rtcmGgaOutput' },
          { valueKey: 'ProductSpecs.values.insGnssImuOutput' }
        ]
      },
      { labelKey: 'ProductSpecs.rows.sleepMode', value: { valueKey: 'ProductSpecs.values.supported' } },
      { labelKey: 'ProductSpecs.rows.operatingVoltage', value: '9-16V' },
      { labelKey: 'ProductSpecs.rows.operatingCurrent', value: '<=0.2A@12V' },
      { labelKey: 'ProductSpecs.rows.operatingTemperature', value: '-40 ~ 85°C (-40 ~ 105°C optional)' },
      { labelKey: 'ProductSpecs.rows.protectionRating', value: 'IP66' }
    ]
  },
  { labelKey: 'ProductSpecs.tabs.antenna', rows: [] },
  { labelKey: 'ProductSpecs.tabs.gnss', rows: [] },
  { labelKey: 'ProductSpecs.tabs.gyroAccelerometer', rows: [] },
  { labelKey: 'ProductSpecs.tabs.gnssDeniedIns', rows: [] }
]

const product = (slug, title, folder, i18nKey, overrides = {}) => ({
  slug,
  title,
  i18nKey,
  variant: 'industry-detail',
  images: {
    hero: require(`@/assets/images/industry-products/${folder}/hero.png`),
    description: require(`@/assets/images/industry-products/${folder}/description.jpg`),
    feature: require(`@/assets/images/industry-products/${folder}/feature.jpg`)
  },
  descriptionTags: commonDescriptionTags,
  featureTags: commonFeatureTags,
  scenarios: commonScenarios,
  specTabs: commonSpecTabs,
  ...overrides
})

export const industryProducts = {
  i10: product('i10', 'I10', 'positioning/i10', 'IndustryProducts.i10', {
    specTabs: [
      {
        labelKey: 'ProductSpecs.tabs.gyro',
        rows: [
          { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'IndustryProducts.i10.specValues.gyro.range' } },
          { labelKey: 'ProductSpecs.rows.零偏稳定性', value: { valueKey: 'IndustryProducts.i10.specValues.gyro.biasStability' } },
          { labelKey: 'ProductSpecs.rows.零偏不稳定性', value: { valueKey: 'IndustryProducts.i10.specValues.gyro.biasInstability' } },
          { labelKey: 'ProductSpecs.rows.全温零偏', value: { valueKey: 'IndustryProducts.i10.specValues.gyro.fullTempBias' } },
          { labelKey: 'ProductSpecs.rows.标度误差', value: { valueKey: 'IndustryProducts.i10.specValues.gyro.scaleError' } },
          { labelKey: 'ProductSpecs.rows.角度随机游走', value: { valueKey: 'IndustryProducts.i10.specValues.gyro.angleRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'IndustryProducts.i10.specValues.gyro.operatingFrequency' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.accelerometer',
        rows: [
          { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'IndustryProducts.i10.specValues.accelerometer.range' } },
          { labelKey: 'ProductSpecs.rows.零偏稳定性', value: { valueKey: 'IndustryProducts.i10.specValues.accelerometer.biasStability' } },
          { labelKey: 'ProductSpecs.rows.零偏不稳定性', value: { valueKey: 'IndustryProducts.i10.specValues.accelerometer.biasInstability' } },
          { labelKey: 'ProductSpecs.rows.全温零偏', value: { valueKey: 'IndustryProducts.i10.specValues.accelerometer.fullTempBias' } },
          { labelKey: 'ProductSpecs.rows.标度误差', value: { valueKey: 'IndustryProducts.i10.specValues.accelerometer.scaleError' } },
          { labelKey: 'ProductSpecs.rows.速度随机游走', value: { valueKey: 'IndustryProducts.i10.specValues.accelerometer.velocityRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'IndustryProducts.i10.specValues.accelerometer.operatingFrequency' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.physicalAndElectrical',
        rows: [
          { labelKey: 'ProductSpecs.rows.尺寸', value: { valueKey: 'IndustryProducts.i10.specValues.physical.dimensions' } },
          { labelKey: 'ProductSpecs.rows.通讯接口', value: { valueKey: 'IndustryProducts.i10.specValues.physical.communicationInterface' } },
          { labelKey: 'ProductSpecs.rows.供电电压', value: { valueKey: 'IndustryProducts.i10.specValues.physical.supplyVoltage' } },
          { labelKey: 'ProductSpecs.rows.主连接器类型', value: { valueKey: 'IndustryProducts.i10.specValues.physical.connectorModel' } },
          { labelKey: 'ProductSpecs.rows.功耗', value: { valueKey: 'IndustryProducts.i10.specValues.physical.powerConsumption' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.environmentParams',
        rows: [
          { labelKey: 'ProductSpecs.rows.工作温度', value: { valueKey: 'IndustryProducts.i10.specValues.environment.operatingTemperature' } },
          { labelKey: 'ProductSpecs.rows.存储温度', value: { valueKey: 'IndustryProducts.i10.specValues.environment.storageTemperature' } }
        ]
      }
    ]
  }),
  ix10: product('ix10', 'IX10', 'positioning/ix10', 'IndustryProducts.ix10', {
    specTabs: [
      {
        labelKey: 'ProductSpecs.tabs.gyro',
        rows: [
          { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'IndustryProducts.ix10.specValues.gyro.range' } },
          { labelKey: 'ProductSpecs.rows.零偏稳定性', value: { valueKey: 'IndustryProducts.ix10.specValues.gyro.biasStability' } },
          { labelKey: 'ProductSpecs.rows.零偏不稳定性', value: { valueKey: 'IndustryProducts.ix10.specValues.gyro.biasInstability' } },
          { labelKey: 'ProductSpecs.rows.全温零偏', value: { valueKey: 'IndustryProducts.ix10.specValues.gyro.fullTempBias' } },
          { labelKey: 'ProductSpecs.rows.标度误差', value: { valueKey: 'IndustryProducts.ix10.specValues.gyro.scaleError' } },
          { labelKey: 'ProductSpecs.rows.角度随机游走', value: { valueKey: 'IndustryProducts.ix10.specValues.gyro.angleRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'IndustryProducts.ix10.specValues.gyro.operatingFrequency' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.accelerometer',
        rows: [
          { labelKey: 'ProductSpecs.rows.量程', value: { valueKey: 'IndustryProducts.ix10.specValues.accelerometer.range' } },
          { labelKey: 'ProductSpecs.rows.零偏稳定性', value: { valueKey: 'IndustryProducts.ix10.specValues.accelerometer.biasStability' } },
          { labelKey: 'ProductSpecs.rows.零偏不稳定性', value: { valueKey: 'IndustryProducts.ix10.specValues.accelerometer.biasInstability' } },
          { labelKey: 'ProductSpecs.rows.全温零偏', value: { valueKey: 'IndustryProducts.ix10.specValues.accelerometer.fullTempBias' } },
          { labelKey: 'ProductSpecs.rows.标度误差', value: { valueKey: 'IndustryProducts.ix10.specValues.accelerometer.scaleError' } },
          { labelKey: 'ProductSpecs.rows.速度随机游走', value: { valueKey: 'IndustryProducts.ix10.specValues.accelerometer.velocityRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.工作频率', value: { valueKey: 'IndustryProducts.ix10.specValues.accelerometer.operatingFrequency' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.physicalAndElectrical',
        rows: [
          { labelKey: 'ProductSpecs.rows.尺寸', value: { valueKey: 'IndustryProducts.ix10.specValues.physical.dimensions' } },
          { labelKey: 'ProductSpecs.rows.通讯接口', value: { valueKey: 'IndustryProducts.ix10.specValues.physical.communicationInterface' } },
          { labelKey: 'ProductSpecs.rows.供电电压', value: { valueKey: 'IndustryProducts.ix10.specValues.physical.supplyVoltage' } },
          { labelKey: 'ProductSpecs.rows.主连接器类型', value: { valueKey: 'IndustryProducts.ix10.specValues.physical.connectorModel' } },
          { labelKey: 'ProductSpecs.rows.功耗', value: { valueKey: 'IndustryProducts.ix10.specValues.physical.powerConsumption' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.environmentParams',
        rows: [
          { labelKey: 'ProductSpecs.rows.工作温度', value: { valueKey: 'IndustryProducts.ix10.specValues.environment.operatingTemperature' } },
          { labelKey: 'ProductSpecs.rows.存储温度', value: { valueKey: 'IndustryProducts.ix10.specValues.environment.storageTemperature' } }
        ]
      }
    ]
  }),
  p100a: product('p100a', 'P100A', 'positioning/p100a', 'IndustryProducts.p100a', {
    specTabs: [
      {
        labelKey: 'ProductSpecs.tabs.gnss',
        rows: [
          { labelKey: 'ProductSpecs.rows.信号跟踪（全系统全频）', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.signalTracking' } },
          { labelKey: 'ProductSpecs.rows.水平定位精度', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.horizontalAccuracy' } },
          { labelKey: 'ProductSpecs.rows.高程定位精度', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.verticalAccuracy' } },
          { labelKey: 'ProductSpecs.rows.定向精度', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.headingAccuracy' } },
          { labelKey: 'ProductSpecs.rows.测速精度', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.velocityAccuracy' } },
          { labelKey: 'ProductSpecs.rows.PPS授时精度', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.ppsAccuracy' } },
          { labelKey: 'ProductSpecs.rows.冷启动时间', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.coldStart' } },
          { labelKey: 'ProductSpecs.rows.热启动时间', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.hotStart' } },
          { labelKey: 'ProductSpecs.rows.初始化时间', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.initTime' } },
          { labelKey: 'ProductSpecs.rows.失锁重捕获时间', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.reacquisition' } },
          { labelKey: 'ProductSpecs.rows.原始观测量数据更新频率', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.rawUpdateRate' } },
          { labelKey: 'ProductSpecs.rows.RTK定位数据更新频率', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.rtkUpdateRate' } },
          { labelKey: 'ProductSpecs.rows.单点定位数据更新频率', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.singlePointUpdateRate' } },
          { labelKey: 'ProductSpecs.rows.定向数据更新频率', value: { valueKey: 'IndustryProducts.p100a.specValues.gnss.headingUpdateRate' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.imu',
        rows: [
          { labelKey: 'ProductSpecs.rows.陀螺类型', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.gyroType' } },
          { labelKey: 'ProductSpecs.rows.陀螺量程', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.gyroRange' } },
          { labelKey: 'ProductSpecs.rows.陀螺零偏不稳定性（ALLAN）', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.gyroBiasInstability' } },
          { labelKey: 'ProductSpecs.rows.陀螺角度随机游走（ALLAN）', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.gyroAngleRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.加速度计量程', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.accelerometerRange' } },
          { labelKey: 'ProductSpecs.rows.加速度计零偏不稳定性（ALLAN）', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.accelerometerBiasInstability' } },
          { labelKey: 'ProductSpecs.rows.加速度计速度随机游走（ALLAN）', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.accelerometerVelocityRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.输出频率', value: { valueKey: 'IndustryProducts.p100a.specValues.imu.outputRate' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.gnssDeniedIns',
        rows: [
          { labelKey: 'ProductSpecs.rows.水平位置精度', value: { valueKey: 'IndustryProducts.p100a.specValues.denied.horizontalPositionAccuracy' } },
          { labelKey: 'ProductSpecs.rows.高程位置精度', value: { valueKey: 'IndustryProducts.p100a.specValues.denied.verticalPositionAccuracy' } },
          { labelKey: 'ProductSpecs.rows.水平速度精度', value: { valueKey: 'IndustryProducts.p100a.specValues.denied.horizontalVelocityAccuracy' } },
          { labelKey: 'ProductSpecs.rows.高程速度精度', value: { valueKey: 'IndustryProducts.p100a.specValues.denied.verticalVelocityAccuracy' } },
          { labelKey: 'ProductSpecs.rows.航向精度', value: { valueKey: 'IndustryProducts.p100a.specValues.denied.headingAccuracy' } }
        ]
      }
    ]
  }),
  p200a: product('p200a', 'P200A', 'positioning/p200a', 'IndustryProducts.p200a', {
    specTabs: [
      {
        labelKey: 'ProductSpecs.tabs.gnss',
        rows: [
          { labelKey: 'ProductSpecs.rows.信号跟踪（全系统全频）', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.signalTracking' } },
          { labelKey: 'ProductSpecs.rows.水平定位精度', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.horizontalAccuracy' } },
          { labelKey: 'ProductSpecs.rows.高程定位精度', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.verticalAccuracy' } },
          { labelKey: 'ProductSpecs.rows.定向精度', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.headingAccuracy' } },
          { labelKey: 'ProductSpecs.rows.测速精度', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.velocityAccuracy' } },
          { labelKey: 'ProductSpecs.rows.PPS授时精度', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.ppsAccuracy' } },
          { labelKey: 'ProductSpecs.rows.冷启动时间', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.coldStart' } },
          { labelKey: 'ProductSpecs.rows.热启动时间', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.hotStart' } },
          { labelKey: 'ProductSpecs.rows.初始化时间', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.initTime' } },
          { labelKey: 'ProductSpecs.rows.失锁重捕获时间', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.reacquisition' } },
          { labelKey: 'ProductSpecs.rows.原始观测量数据更新频率', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.rawUpdateRate' } },
          { labelKey: 'ProductSpecs.rows.RTK定位数据更新频率', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.rtkUpdateRate' } },
          { labelKey: 'ProductSpecs.rows.单点定位数据更新频率', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.singlePointUpdateRate' } },
          { labelKey: 'ProductSpecs.rows.定向数据更新频率', value: { valueKey: 'IndustryProducts.p200a.specValues.gnss.headingUpdateRate' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.imu',
        rows: [
          { labelKey: 'ProductSpecs.rows.陀螺类型', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.gyroType' } },
          { labelKey: 'ProductSpecs.rows.陀螺量程', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.gyroRange' } },
          { labelKey: 'ProductSpecs.rows.陀螺零偏不稳定性（ALLAN）', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.gyroBiasInstability' } },
          { labelKey: 'ProductSpecs.rows.陀螺角度随机游走（ALLAN）', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.gyroAngleRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.加速度计量程', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.accelerometerRange' } },
          { labelKey: 'ProductSpecs.rows.加速度计零偏不稳定性（ALLAN）', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.accelerometerBiasInstability' } },
          { labelKey: 'ProductSpecs.rows.加速度计速度随机游走（ALLAN）', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.accelerometerVelocityRandomWalk' } },
          { labelKey: 'ProductSpecs.rows.输出频率', value: { valueKey: 'IndustryProducts.p200a.specValues.imu.outputRate' } }
        ]
      },
      {
        labelKey: 'ProductSpecs.tabs.gnssDeniedIns',
        rows: [
          { labelKey: 'ProductSpecs.rows.水平位置精度', value: { valueKey: 'IndustryProducts.p200a.specValues.denied.horizontalPositionAccuracy' } },
          { labelKey: 'ProductSpecs.rows.高程位置精度', value: { valueKey: 'IndustryProducts.p200a.specValues.denied.verticalPositionAccuracy' } },
          { labelKey: 'ProductSpecs.rows.水平速度精度', value: { valueKey: 'IndustryProducts.p200a.specValues.denied.horizontalVelocityAccuracy' } },
          { labelKey: 'ProductSpecs.rows.高程速度精度', value: { valueKey: 'IndustryProducts.p200a.specValues.denied.verticalVelocityAccuracy' } },
          { labelKey: 'ProductSpecs.rows.航向精度', value: { valueKey: 'IndustryProducts.p200a.specValues.denied.headingAccuracy' } }
        ]
      }
    ]
  }),
  dc100: product('dc100', 'DC100', 'domain-control/dc100', 'IndustryProducts.dc100', {
    descriptionTags: domainDescriptionTags,
    featureTags: domainFeatureTags,
    specTabs: [
      {
        labelKey: 'IndustryProducts.dc100.specTabs.coreBoardPerformance',
        rows: [
          { labelKey: 'IndustryProducts.dc100.specRows.productModel', value: { valueKey: 'IndustryProducts.dc100.specValues.productModel' } },
          { labelKey: 'IndustryProducts.dc100.specRows.platform', value: { valueKey: 'IndustryProducts.dc100.specValues.platform' } },
          { labelKey: 'IndustryProducts.dc100.specRows.deviceAiPerformance', value: { valueKey: 'IndustryProducts.dc100.specValues.deviceAiPerformance' } },
          { labelKey: 'IndustryProducts.dc100.specRows.aiPerformance', value: { valueKey: 'IndustryProducts.dc100.specValues.aiPerformance' } },
          { labelKey: 'IndustryProducts.dc100.specRows.gpu', value: { valueKey: 'IndustryProducts.dc100.specValues.gpu' } },
          { labelKey: 'IndustryProducts.dc100.specRows.cpu', value: { valueKey: 'IndustryProducts.dc100.specValues.cpu' } },
          { labelKey: 'IndustryProducts.dc100.specRows.cpuMaxFrequency', value: { valueKey: 'IndustryProducts.dc100.specValues.cpuMaxFrequency' } },
          { labelKey: 'IndustryProducts.dc100.specRows.videoOutput', value: { valueKey: 'IndustryProducts.dc100.specValues.videoOutput' } },
          { labelKey: 'IndustryProducts.dc100.specRows.usb', value: { valueKey: 'IndustryProducts.dc100.specValues.usb' } },
          { labelKey: 'IndustryProducts.dc100.specRows.can', value: { valueKey: 'IndustryProducts.dc100.specValues.can' } },
          { labelKey: 'IndustryProducts.dc100.specRows.uart', value: { valueKey: 'IndustryProducts.dc100.specValues.uart' } },
          { labelKey: 'IndustryProducts.dc100.specRows.gpioPps', value: { valueKey: 'IndustryProducts.dc100.specValues.gpioPps' } },
          { labelKey: 'IndustryProducts.dc100.specRows.ethernet', value: { valueKey: 'IndustryProducts.dc100.specValues.ethernet' } },
          { labelKey: 'IndustryProducts.dc100.specRows.storage', value: { valueKey: 'IndustryProducts.dc100.specValues.storage' } },
          { labelKey: 'IndustryProducts.dc100.specRows.gnss', value: { valueKey: 'IndustryProducts.dc100.specValues.gnss' } },
          { labelKey: 'IndustryProducts.dc100.specRows.imu', value: { valueKey: 'IndustryProducts.dc100.specValues.imu' } },
          { labelKey: 'IndustryProducts.dc100.specRows.fourG', value: { valueKey: 'IndustryProducts.dc100.specValues.fourG' } },
          { labelKey: 'IndustryProducts.dc100.specRows.bootMode', value: { valueKey: 'IndustryProducts.dc100.specValues.bootMode' } },
          { labelKey: 'IndustryProducts.dc100.specRows.coolingMode', value: { valueKey: 'IndustryProducts.dc100.specValues.coolingMode' } },
          { labelKey: 'IndustryProducts.dc100.specRows.powerSupply', value: { valueKey: 'IndustryProducts.dc100.specValues.powerSupply' } }
        ]
      },
      {
        labelKey: 'IndustryProducts.dc100.specTabs.workingEnvironment',
        rows: [
          { labelKey: 'IndustryProducts.dc100.specRows.workingTemperature', value: { valueKey: 'IndustryProducts.dc100.specValues.workingTemperature' } },
          { labelKey: 'IndustryProducts.dc100.specRows.storageTemperature', value: { valueKey: 'IndustryProducts.dc100.specValues.storageTemperature' } },
          { labelKey: 'IndustryProducts.dc100.specRows.relativeHumidity', value: { valueKey: 'IndustryProducts.dc100.specValues.relativeHumidity' } },
          { labelKey: 'IndustryProducts.dc100.specRows.maxPower', value: { valueKey: 'IndustryProducts.dc100.specValues.maxPower' } },
          { labelKey: 'IndustryProducts.dc100.specRows.protectionRating', value: { valueKey: 'IndustryProducts.dc100.specValues.protectionRating' } }
        ]
      },
      {
        labelKey: 'IndustryProducts.dc100.specTabs.dimensions',
        rows: [
          { labelKey: 'IndustryProducts.dc100.specRows.productDimensions', value: { valueKey: 'IndustryProducts.dc100.specValues.productDimensions' } }
        ]
      }
    ]
  }),
  dc200: product('dc200', 'DC200', 'domain-control/dc200', 'IndustryProducts.dc200', {
    descriptionTags: domainDescriptionTags,
    featureTags: domainFeatureTags,
    specTabs: [
      {
        labelKey: 'IndustryProducts.dc200.specTabs.coreBoardPerformance',
        rows: [
          { labelKey: 'IndustryProducts.dc200.specRows.productModel', value: { valueKey: 'IndustryProducts.dc200.specValues.productModel' } },
          { labelKey: 'IndustryProducts.dc200.specRows.platform', value: { valueKey: 'IndustryProducts.dc200.specValues.platform' } },
          { labelKey: 'IndustryProducts.dc200.specRows.deviceAiPerformance', value: { valueKey: 'IndustryProducts.dc200.specValues.deviceAiPerformance' } },
          { labelKey: 'IndustryProducts.dc200.specRows.aiPerformance', value: { valueKey: 'IndustryProducts.dc200.specValues.aiPerformance' } },
          { labelKey: 'IndustryProducts.dc200.specRows.singleCoreGpu', value: { valueKey: 'IndustryProducts.dc200.specValues.singleCoreGpu' } },
          { labelKey: 'IndustryProducts.dc200.specRows.singleCoreGpuMaxFrequency', value: { valueKey: 'IndustryProducts.dc200.specValues.singleCoreGpuMaxFrequency' } },
          { labelKey: 'IndustryProducts.dc200.specRows.singleCoreCpu', value: { valueKey: 'IndustryProducts.dc200.specValues.singleCoreCpu' } },
          { labelKey: 'IndustryProducts.dc200.specRows.cpuMaxFrequency', value: { valueKey: 'IndustryProducts.dc200.specValues.cpuMaxFrequency' } },
          { labelKey: 'IndustryProducts.dc200.specRows.memory', value: { valueKey: 'IndustryProducts.dc200.specValues.memory' } }
        ]
      },
      {
        labelKey: 'IndustryProducts.dc200.specTabs.peripheralInterfaces',
        rows: [
          { labelKey: 'IndustryProducts.dc200.specRows.videoOutput', value: { valueKey: 'IndustryProducts.dc200.specValues.videoOutput' } },
          { labelKey: 'IndustryProducts.dc200.specRows.camera', value: { valueKey: 'IndustryProducts.dc200.specValues.camera' } },
          { labelKey: 'IndustryProducts.dc200.specRows.usb', value: { valueKey: 'IndustryProducts.dc200.specValues.usb' } },
          { labelKey: 'IndustryProducts.dc200.specRows.can', value: { valueKey: 'IndustryProducts.dc200.specValues.can' } },
          { labelKey: 'IndustryProducts.dc200.specRows.uart', value: { valueKey: 'IndustryProducts.dc200.specValues.uart' } },
          { labelKey: 'IndustryProducts.dc200.specRows.gpioPps', value: { valueKey: 'IndustryProducts.dc200.specValues.gpioPps' } },
          { labelKey: 'IndustryProducts.dc200.specRows.ethernet', value: { valueKey: 'IndustryProducts.dc200.specValues.ethernet' } },
          { labelKey: 'IndustryProducts.dc200.specRows.ssd', value: { valueKey: 'IndustryProducts.dc200.specValues.ssd' } },
          { labelKey: 'IndustryProducts.dc200.specRows.gnss', value: { valueKey: 'IndustryProducts.dc200.specValues.gnss' } },
          { labelKey: 'IndustryProducts.dc200.specRows.imu', value: { valueKey: 'IndustryProducts.dc200.specValues.imu' } },
          { labelKey: 'IndustryProducts.dc200.specRows.fourG', value: { valueKey: 'IndustryProducts.dc200.specValues.fourG' } },
          { labelKey: 'IndustryProducts.dc200.specRows.bootMode', value: { valueKey: 'IndustryProducts.dc200.specValues.bootMode' } },
          { labelKey: 'IndustryProducts.dc200.specRows.coolingMode', value: { valueKey: 'IndustryProducts.dc200.specValues.coolingMode' } },
          { labelKey: 'IndustryProducts.dc200.specRows.powerSupply', value: { valueKey: 'IndustryProducts.dc200.specValues.powerSupply' } }
        ]
      },
      {
        labelKey: 'IndustryProducts.dc200.specTabs.workingEnvironment',
        rows: [
          { labelKey: 'IndustryProducts.dc200.specRows.workingTemperature', value: { valueKey: 'IndustryProducts.dc200.specValues.workingTemperature' } },
          { labelKey: 'IndustryProducts.dc200.specRows.storageTemperature', value: { valueKey: 'IndustryProducts.dc200.specValues.storageTemperature' } },
          { labelKey: 'IndustryProducts.dc200.specRows.relativeHumidity', value: { valueKey: 'IndustryProducts.dc200.specValues.relativeHumidity' } },
          { labelKey: 'IndustryProducts.dc200.specRows.maxPower', value: { valueKey: 'IndustryProducts.dc200.specValues.maxPower' } },
          { labelKey: 'IndustryProducts.dc200.specRows.protectionRating', value: { valueKey: 'IndustryProducts.dc200.specValues.protectionRating' } }
        ]
      },
      {
        labelKey: 'IndustryProducts.dc200.specTabs.dimensions',
        rows: [
          { labelKey: 'IndustryProducts.dc200.specRows.productDimensions', value: { valueKey: 'IndustryProducts.dc200.specValues.productDimensions' } },
          { labelKey: 'IndustryProducts.dc200.specRows.productWeight', value: { valueKey: 'IndustryProducts.dc200.specValues.productWeight' } }
        ]
      }
    ]
  })
}
